import React from 'react';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Layout from 'components/Layout';
import hasAuthToken from 'lib/hasAuthToken';

const AboutDeBanensitePage = () => {
  const { t } = useTranslation();

  return (
    <Layout title={t('aboutDeBanensite.pageTitle')}>
      <div className="o-retain o-retain--lap u-margin-top-huge u-margin-bottom-huge">
        <h1>{t('aboutDeBanensite.pageHeading')}</h1>
        <p>
          <strong>deBanenSite.nl</strong> is hét jobmarketing platform in
          Nederland, ontworpen om organisaties te ondersteunen in elke stap van
          het wervingsproces. Met ons alles-in-één platform bieden wij een
          efficiënte en resultaatgerichte oplossing voor al uw online
          recruitmentbehoeften.
        </p>
        <p>
          <strong>Wat biedt deBanenSite.nl?</strong>
          <br />
          Met deBanenSite.nl profiteert u van een breed scala aan diensten en
          tools:
          <br />
          <br />
          <ul>
            <li>
              <strong>Eenvoudig vacatures plaatsen:</strong> Uw vacatures zijn
              direct zichtbaar op deBanenSite.nl én ons uitgebreide
              partnernetwerk, waaronder LinkedIn, Indeed en Google for Jobs.
            </li>
            <li>
              <strong>Werkgeversimago versterken:</strong> Creëer een unieke
              bedrijfspagina en zet gerichte campagnes in om uw organisatie
              aantrekkelijk te positioneren.
            </li>
            <li>
              <strong>Toegang tot een uitgebreide cv-database:</strong> Zoek
              actief tussen 480.000 kandidaten en ontvang e-mailalerts met
              geschikte profielen.
            </li>
            <li>
              <strong>Applicant Tracking System (ATS):</strong> Beheer
              sollicitaties efficiënt via ons gebruiksvriendelijke systeem.
            </li>
            <li>
              <strong>Werken-bij websites:</strong> Kies voor een basic template
              of een volledig op maat gemaakte werken-bij website, afgestemd op
              uw organisatie.
            </li>
            <li>
              <strong>
                Jobmarketing op nationaal en internationaal niveau:
              </strong>{' '}
              Adverteer op meer dan 3.000 kanalen, van socialmedia campagnes op
              Facebook, Instagram en TikTok tot nichewebsites.
            </li>
          </ul>
        </p>

        <p>
          <strong>Waarom kiezen voor deBanenSite.nl?</strong>
          <br />
          Bij deBanenSite.nl brengen we alles samen in één krachtig platform. Zo
          besparen we u tijd en moeite, terwijl u verzekerd bent van een
          continue instroom van gekwalificeerde kandidaten. Met meer dan{' '}
          <strong>34.000 organisaties in Nederland</strong> die ons platform
          gebruiken, zijn wij de ervaren partner die u zoekt voor uw online
          werving.
          <br />
          <br />
          <strong>Start vandaag nog</strong> en ontdek hoe deBanenSite.nl uw
          wervingsproces naar een hoger niveau tilt!
          <br />
          <br />
          Heeft u interesse of wilt u meer weten?{' '}
          <strong>Boek vrijblijvend een demo</strong> of neem contact met ons
          op.
        </p>
      </div>
    </Layout>
  );
};

export async function getServerSideProps({ req, res, locale }) {
  if (!hasAuthToken(req)) {
    res.setHeader(
      'Cache-Control',
      'public, max-age=300, s-maxage=300, stale-while-revalidate=600'
    );
  }

  return {
    props: {
      ...(await serverSideTranslations(locale, ['common'])),
    },
  };
}

export default AboutDeBanensitePage;
